import React, { useState, useEffect } from 'react'
//Helpers
import { ElementHTML } from '@helpers/helper.rendering'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'
import useQueryProperty from '@hooks/useQueryProperty'
import {
  getAge,
  getBathrooms,
  getEnvironment,
  getOrientation,
  getPrices,
  getRooms,
  getSurfaces,
  getType,
} from '@helpers/helper.properties'

const AboutProperty_5 = ({
  propertyID,
  global_data,
}: { propertyID: string } & RealEstateDataPageComponentData) => {
  const { data: allPropertyData, isLoading } = useQueryProperty(
    propertyID,
    global_data.pageConfig.keys.tokko,
  )
  return (
    <section className={'property-about-5 ser'}>
      <Container fluid>
        {/* <Row
              className={`h-100 position-relative justify-content-end item-row`}
            >
                <Col
                  xs={12}
                  md={item.align !== 'center' ? 10 : 12}
                  className="h-100"
                >
                  <Image
                    image={item.image_gatsby}
                    objectFit="cover"
                    alt="img-aboutus"
                    className=""
                    style={{
                      height: getHeight(),
                    }}
                  />
                  {item.align === 'center' && !isMobile && <div className="white-strip" />}

                  <div
                    className={`content-div ${
                      item?.align === 'left'
                        ? 'align-start'
                        : item?.align === 'right'
                        ? 'align-end'
                        : 'align-center'
                    } p-5`}
                  >
                    <ElementHTML
                      children={item?.subtitle || ''}
                      elementType={'h5'}
                      className={'mb-lg-4 mt-lg-1 mb-3'}
                    />
                    <ElementHTML
                      children={item?.title || ''}
                      elementType={titleElement || 'h2'}
                      className={'mb-lg-4 mt-lg-1 mb-3 item-title'}
                      style={{ color: titleHexa }}
                    />
                    {item?.paragraphs?.map((paragraph) => (
                      <ElementHTML
                        children={paragraph}
                        elementType="p"
                      />
                    ))}
                  </div>
                </Col>
              )}
            </Row> */}
      </Container>
    </section>
  )
}

export default AboutProperty_5
